// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3827bd2","239":"e78ad9fb","455":"93000e18"}[chunkId] + ".chunk.js";
};